module.exports = __webpack_public_path__ + "img/room-1.65594bc6.jpg";